export const OPERATORS_BY_TYPE = {
  date:    ['between', 'equals', 'gte', 'lte', 'greaterThan', 'lessThan', 'isNull', 'isNotNull'],
  string:  ['equals', 'notEquals', 'contains', 'isNull', 'isNotNull'],
  number:  ['equals', 'notEquals', 'between', 'gte', 'lte', 'greaterThan', 'lessThan', 'isNull', 'isNotNull'],
  boolean: ['equals', 'isNull', 'isNotNull'],
  object:  ['isNull', 'isNotNull'],
  array:   ['isNull', 'isNotNull'],
};

export const OPERATOR_LABELS = {
  between:     'Between',
  equals:      'Equals',
  notEquals:   'Not Equals',
  contains:    'Contains',
  greaterThan: 'After / >',
  lessThan:    'Before / <',
  gte:         'On or After / ≥',
  lte:         'On or Before / ≤',
  isNull:      'Is Null',
  isNotNull:   'Is Not Null',
};

export const NO_VALUE_OPS = new Set(['isNull', 'isNotNull']);

export const defaultOperator = (type) =>
  (OPERATORS_BY_TYPE[type] ?? OPERATORS_BY_TYPE.string)[0];

export const newFilter = () => ({
  id: Date.now() + Math.random(),
  field: '',
  fieldType: 'string',
  operator: 'equals',
  value: '',
  valueTo: '',
});
